export default "__VITE_ASSET__031a54d9__"